import React from 'react';
import { Section } from './ui/Section';
export function Reframe() {
  return <Section className="text-center" data-id="element-151">
      <h2 className="text-3xl md:text-4xl font-serif mb-2 text-warm-brown" data-id="element-152">
        Lo que te está pasando
      </h2>
      <p className="text-sage mb-10 italic" data-id="element-153">(sin diagnóstico, sin drama)</p>

      <div className="space-y-8 text-lg md:text-xl leading-relaxed max-w-xl mx-auto" data-id="element-154">
        <p data-id="element-155">No es que "te falta vibración".</p>
        <p className="text-2xl font-serif text-terracotta" data-id="element-156">
          Es que te falta regulación.
        </p>
        <p data-id="element-157">Tu cuerpo está en alerta.</p>

        <div className="bg-sage-light/30 p-8 rounded-2xl my-8 text-left" data-id="element-158">
          <p className="mb-4 font-medium" data-id="element-159">Y cuando el cuerpo está en alerta:</p>
          <ul className="space-y-3" data-id="element-160">
            <li className="flex items-center gap-3" data-id="element-161">
              <span className="h-1.5 w-1.5 rounded-full bg-terracotta" data-id="element-162"></span>
              <span data-id="element-163">la mente busca explicaciones</span>
            </li>
            <li className="flex items-center gap-3" data-id="element-164">
              <span className="h-1.5 w-1.5 rounded-full bg-terracotta" data-id="element-165"></span>
              <span data-id="element-166">la mente busca señales</span>
            </li>
            <li className="flex items-center gap-3" data-id="element-167">
              <span className="h-1.5 w-1.5 rounded-full bg-terracotta" data-id="element-168"></span>
              <span data-id="element-169">la mente busca control</span>
            </li>
          </ul>
        </div>

        <p data-id="element-170">
          Y ahí aparece la trampa:{' '}
          <strong className="font-medium" data-id="element-171">
            convertir tu espiritualidad en una exigencia.
          </strong>
        </p>
      </div>
    </Section>;
}